import { Component, Input, OnInit, inject } from '@angular/core';

import { map, withLatestFrom } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { CmsComponentData, Logo, LogoComponentData } from '@boels/models';
import { BreakpointService, sampleSize } from '@boels/helpers';
import { MediaService } from '@boels/services';
import { AsyncPipe } from '@angular/common';

@Component({
  imports: [AsyncPipe],
  selector: 'boels-logo-rotator',
  templateUrl: './logo-rotator.component.html',
  styleUrls: ['./logo-rotator.component.scss'],
})
export class LogoRotatorComponent implements OnInit {
  private breakPointService = inject(BreakpointService);
  private mediaService = inject(MediaService);

  private readonly maxLogosMobile = 4;
  private readonly maxLogosDesktop = 5;

  @Input() componentData: CmsComponentData<LogoComponentData>;
  logos$: Observable<Logo[]>;

  ngOnInit(): void {
    this.logos$ = this.breakPointService.mdAndBelow$.pipe(
      withLatestFrom(this.componentData.data$),
      map(([isMobile, data]) =>
        sampleSize(
          Object.values(data.logos),
          isMobile ? this.maxLogosMobile : this.maxLogosDesktop,
        ),
      ),
    );
  }

  getLogoUrl(logo: Logo): string | undefined {
    return this.mediaService.getMedia(logo)?.src;
  }
}
